export default "__VITE_ASSET__i24SGa9t__"